import React, { memo, useState } from 'react';
import { View } from 'react-native';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontSizeTokens } from "@voltmoney/schema";
import { Typography } from "../typography/Typography";
import { Icon } from "../icon/Icon";
import { Button } from "../button/Button";
/**
 * Primary UI component for user interaction
 */
const LlaBenefitCard = ({ items, ctaTitle, ctaAction, triggerAction, enableCta = true }) => {
    const [loading, setLoading] = useState(false);
    const handleAction = () => {
        setLoading(true);
        ctaAction
            && triggerAction(ctaAction);
        setLoading(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: {
                width: '100%',
                padding: 12,
                borderRadius: 8,
                borderWidth: 1,
                borderColor: '#E4E7EC',
                backgroundColor: '#FFF',
            } },
            React.createElement(View, { style: {
                    width: '100%'
                } },
                React.createElement(Typography, { label: "Volt Money benefits", fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: {
                    paddingTop: 24,
                    paddingBottom: 16
                } }, items
                && items.map((item, index) => (React.createElement(React.Fragment, null,
                    React.createElement(View, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            paddingBottom: (index < (items?.length - 1)) ? 16 : 0
                        } },
                        React.createElement(View, { style: {
                                paddingRight: 8
                            } }, item.icon
                            && React.createElement(Icon, { name: item?.icon?.name, color: item?.icon?.color, size: item?.icon?.size })),
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'column'
                            } },
                            item?.title
                                && React.createElement(Typography, { label: `${item?.title}`, fontWeight: '500', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night }),
                            item?.subtitle
                                && React.createElement(Typography, { label: `${item?.subtitle}`, fontWeight: '400', fontSize: FontSizeTokens.XS, lineHeight: 18, color: ColorTokens.Grey_Charcoal }))))))),
            ctaAction &&
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        width: '100%'
                    } },
                    React.createElement(View, { style: {
                            flex: 1,
                            maxWidth: 338
                        } },
                        React.createElement(Button, { type: enableCta ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline, width: ButtonWidthTypeToken.FULL, label: `${ctaTitle}`, fontSize: FontSizeTokens.SM, loading: loading, onPress: () => handleAction() }))))));
};
export default memo(LlaBenefitCard);
export { LlaBenefitCard };
